<div class="modal-body">
    <div class="form-confirm">
        <h3 class="title">Please confirm form submission</h3>
        <div class="info-block">
            <p class="info-block__label">Step name:</p>
            <p class="info-block__content">{{ step.name }}</p>
        </div>
        <div class="info-block">
            <p class="info-block__label">Step type:</p>
            <p class="info-block__content">{{ step.step_type_name }}</p>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="backToPreviousPage()">BACK</button>
    <button type="button" class="btn btn-primary" (click)="confirm.emit()">CONFIRM</button>
</div>
